.profileCard {
  width: 320px;
  background-color: #fff;
  border: 2px solid #2e2e2e;
  border-radius: 12px;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
  margin: 20px auto;
}

.profileHeader {
  padding: 40px 20px;
  text-align: center;
}

.avatarWrapper{
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin: 0 auto 15px;
  overflow: hidden;
  border: 2px solid #2e2e2e;
}

.avatarImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.name {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #000;
}

.username, .location {
  font-size: 16px;
  color: #757575;
  margin-bottom: 4px;
}


.statsList {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  border-top: 2px solid #757575;
  background-color: #dcdcdc; 
}

.statsItem {
  flex: 1;
  padding: 15px 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.statsItem:not(:last-child) {
  border-right: 2px solid #757575;
}

.statsLabel{
  font-size: 14px;
  color: #000;
  margin-bottom: 5px;
}

.statsValue {
  font-size: 18px;
  font-weight: 800;
  color: #000;
}